import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { printSummaryBillApi } from "../../../services/billing.service";
import { toast } from "react-toastify";

const PrintModal = ({ open, onClose, id }) => {
  const [summaryBillPrintLoading, setSummaryBillPrintLoading] = useState(false);

  const handleSummaryBillPrint = async () => {
    setSummaryBillPrintLoading(true);
    
    try {
      const response = await printSummaryBillApi(id);
      setSummaryBillPrintLoading(false);

      // Check for error from api.request
      if (!response || response.error) {
        toast.error("Failed to fetch PDF");
        return;
      }

      // Check if response is valid ArrayBuffer or Blob-compatible
      if (
        !(
          response instanceof ArrayBuffer ||
          response instanceof Blob ||
          response.byteLength
        )
      ) {
        toast.error("Invalid PDF data received");
        return;
      }

      const blob = new Blob([response], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const printWindow = window.open(blobUrl, "_blank");

      // Handle popup blocker
      if (!printWindow) {
        console.error("Popup blocked. Please allow popups for this site.");
        return;
      }

      // Optional: Delay to give time for the PDF to load before printing
      printWindow.onload = () => {
        onClose();
        printWindow.focus();
        printWindow.print();
      };
    } catch (error) {
      console.error("Error generating PDF:", error);
      setSummaryBillPrintLoading(false);
      toast.error("Error generating PDF");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "900px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "350px",
            gap: 4,
          }}
        >
          <Box
            sx={{
              border: "1px solid rgba(93, 106, 130, 1)",
              width: "40%",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "8px",
              p: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: "rgba(35, 42, 56, 1)", textAlign: "center" }}
            >
              Bill Summary
            </Typography>
            <Typography
              sx={{ color: "rgba(93, 106, 130, 1)", textAlign: "center" }}
            >
              Print Concise Summary Of Charges With Total Payable Amount.
            </Typography>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderColor: "rgba(22, 63, 98, 1)",
                color: "rgba(22, 63, 98, 1)",
                width: "133px",
              }}
              disabled={summaryBillPrintLoading}
              onClick={handleSummaryBillPrint}
            >
              {summaryBillPrintLoading ? (
                <CircularProgress size={20} />
              ) : (
                "Print Summary"
              )}
            </Button>
          </Box>
          {/* <Box
            sx={{
              border: "1px solid rgba(93, 106, 130, 1)",
              width: "40%",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "8px",
              p: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: "rgba(35, 42, 56, 1)", textAlign: "center" }}
            >
              Detailed Bill
            </Typography>
            <Typography
              sx={{ color: "rgba(93, 106, 130, 1)", textAlign: "center" }}
            >
              Print Itemized Breakdown Of All Charges For Full Transparency.
            </Typography>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderColor: "rgba(22, 63, 98, 1)",
                color: "rgba(22, 63, 98, 1)",
                width: "133px",
              }}
            >
              Print Detailed
            </Button>
          </Box> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PrintModal;
